import { render } from "./AddEditStock.vue?vue&type=template&id=1153191f&scoped=true"
import script from "./AddEditStock.vue?vue&type=script&lang=js"
export * from "./AddEditStock.vue?vue&type=script&lang=js"

import "./AddEditStock.vue?vue&type=style&index=0&id=1153191f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1153191f"]])

export default __exports__